<template>
    <v-container v-if="selectedPlantID && weatherData != null" class="pa-0" grid-list-md>
        <v-layout row align-center>
            <v-flex align-self-center>
                <span>{{ today }}</span>
            </v-flex>
            <v-flex v-if="plant" align-self-center>
                <span>{{ plantName }}</span>
            </v-flex>
            <v-flex v-if="todayWeather" align-self-center  @click="showWeatherForecast">
                <WeatherIcon 
                    style="filter: brightness(0) invert(1)" 
                    :heigth="48" 
                    :width="48" 
                    :weather-icon-name="todayIcon">
                </WeatherIcon>
            </v-flex>
            <v-flex v-if="todayWeather" align-self-center>
                <v-layout column align-center>
                    <v-flex class="py-0">
                        <span>{{ todayMax }}°C</span>
                    </v-flex>
                    <v-flex class="py-0">
                        <span>{{ todayMin }}°C</span>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-else-if="loadingWeatherData">
                <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
        </v-layout>
        <v-bottom-sheet v-model="weatherForecastBottomSheet" inset @keydown.esc="weatherForecastBottomSheet = false">
            <v-card>
                <v-card-title primary-title class="primary white--text sticky-header">
                    <div>
                        <h3 class="headline mb-0">Weather for {{plantName}}</h3>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap align-center justify-center>
                        <weather-forecast v-for="(forecastsWeather, i) in forecastWeathers" :key="i" :weather="forecastsWeather"></weather-forecast>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-bottom-sheet>
    </v-container>
</template>

<script>
import moment from 'moment'
import WeatherIcon from '@/components/harvestPlan/WeatherIcon.vue'
import WeatherForecast from "@/components/harvestPlan/WeatherForecast.vue"

import { mapState } from "vuex"

export default {
    components: {
        WeatherIcon,
        WeatherForecast
    },
    data(){
        return {
            moment,
            weatherForecastBottomSheet: false,
             labels: ['SU', 'MO', 'TU', 'WED', 'TH', 'FR', 'SA'],
        time: 0,
        forecast: [
          { day: 'Tuesday', icon: 'mdi-white-balance-sunny', temp: '24\xB0/12\xB0' },
          { day: 'Wednesday', icon: 'mdi-white-balance-sunny', temp: '22\xB0/14\xB0' },
          { day: 'Thursday', icon: 'mdi-cloud', temp: '25\xB0/15\xB0' },
        ],
        };
    },
    computed: {
        ...mapState("HarvestPlanStore", [
            "loadingWeatherData",
            "plantData",
            "selectedPlantID",
            "weatherData"
        ]),
        plant(){
            return this.plantData.find(x => x.PlantID === this.selectedPlantID);
        },
        plantName(){
            return this.plant.PlantName;
        },
        today(){
            return this.$options.filters.formatDate(moment());
        },
        todayWeather(){
            return this.weatherData.find(x => 
                x.PlantID === this.selectedPlantID
                && moment(x.TemperatureDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
            )
        },
        forecastWeathers() {
            return this.weatherData.filter(w=> {
                return moment(w.TemperatureDate).isSameOrAfter(moment().startOf('day'));
            });
        },
        todayMin(){
            return Math.round(this.todayWeather.TemperatureMin);
        },
        todayMax(){
            return Math.round(this.todayWeather.TemperatureMax);
        },
        todayHumidity() {
            return this.todayWeather.Humidity;
        },
        todaySummary(){
            return this.todayWeather.Summary;
        },
        todayIcon(){
            return this.todayWeather.Icon;
        }
    },
    methods: {
        showWeatherForecast() {
            this.weatherForecastBottomSheet = true;
        }
    },
    created(){
        
    }
}
</script>